export default "mutation($events: [EventType!]!) {\n  reportDyEvents(events: $events) {\n    success\n    message\n  }\n}\n"